import React from 'react'
import styled from 'styled-components'
import { TransitionsAnim } from 'animations/Transitions'

interface LAYER_PROPS {
  fadeIn?: boolean
  fadeOut?: boolean
}

const { fadeIn } = TransitionsAnim()

const Layer = styled.div<LAYER_PROPS>`
  background: rgba(32, 30, 30, 0.6);
  position: absolute;
  width: 375px;
  height: 667px;
  left: -30px;
  top: -30px;
  z-index: 1;
  opacity: 0;
  ${fadeIn}
`

export default function BackLayer({ fadeOut }: any) {
  return <Layer fadeOut={fadeOut} />
}
